import { FC } from 'react';
import { Result } from '../../Result';

const FetchErrorResult: FC = () => (
  <Result severity="error" title="Sorry. Something went wrong." subtitle="Please refresh the page and try again." />
);

export default FetchErrorResult;
